exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tabs__labels{margin:0;padding:0}.tabs__labels li{display:inline-block;padding:0 16px;margin:0}.tabs__labels li:first-child{padding-left:0}.tabs__labels li:last-child{padding-right:0}.tabs__labels li a,.tabs__labels li a.light{padding:8px 0;display:block;text-decoration:none;border-bottom:3px solid transparent}.tabs__labels li a{color:#6a7070}.tabs__labels li a:focus,.tabs__labels li a:hover{color:#252525;border-bottom:3px solid #c7c7c7}.tabs__labels li a.light{color:#d9d9d9}.tabs__labels li a.light:hover{color:#fff;border-bottom:3px solid #d9d9d9}.tabs__labels li a.light.activeTab{color:#fff}.tabs__labels li a.activeTab{border-bottom-color:#19a6a4;color:#252525}.tabs__labels li a.activeTab:hover{border-bottom:3px solid #19a6a4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/Tabs/Tabs.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/Tabs/Tabs.scss
// module chunks = 0 1 2